import clsx from 'clsx';
import React, { useRef } from 'react';

type DropdownMenuProps = {
  isOpen: boolean;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  items?: string[];
  onItemClick: (item: string) => void;
  children?: React.ReactNode;
  className?: string;
};

export const DropdownMenu = ({
  isOpen,
  position = 'bottom-right',
  items = [],
  onItemClick,
  children,
  className,
}: DropdownMenuProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const positionClasses = {
    'bottom-right': 'right-0 mt-1',
    'bottom-left': 'left-0 mt-1',
    'top-right': 'right-0 mb-1 bottom-full',
    'top-left': 'left-0 mb-1 bottom-full',
  };

  if (!isOpen) return null;

  return (
    <div
      ref={menuRef}
      className={clsx(
        'absolute z-[9999] bg-neutral-0 shadow-lg rounded-md py-1',
        'overflow-auto focus:outline-none text-sm',
        'border border-neutral-100',
        'min-w-[180px] max-w-[280px]',
        positionClasses[position],
        className,
      )}
    >
      <ul>
        {items.map((item, index) => (
          <li
            key={index}
            className="px-3 py-2.5 hover:bg-neutral-50 cursor-pointer text-neutral-700"
            onClick={() => onItemClick(item)}
          >
            {item}
          </li>
        ))}
        {children}
      </ul>
    </div>
  );
};
